import { createFileRoute } from "@tanstack/react-router";

import { PraxaChannelManagement } from "../components/praxa/PraxaChannelManagementSurface";

export const Route = createFileRoute("/w/$workspaceId/channels/manage")({
  component: PraxaChannelManagementRoute,
});

function PraxaChannelManagementRoute() {
  const { workspaceId } = Route.useParams();
  return <PraxaChannelManagement workspaceId={workspaceId} />;
}
